import { render } from "./emailVerify.vue?vue&type=template&id=0bbd71d1&scoped=true"
import script from "./emailVerify.vue?vue&type=script&lang=js"
export * from "./emailVerify.vue?vue&type=script&lang=js"

import "./emailVerify.vue?vue&type=style&index=0&id=0bbd71d1&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbd71d1"]])

export default __exports__